var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseLogo5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 11.5352C9.10653 11.5352 7.23067 12.3122 5.84759 13.6952C4.46451 15.0783 3.6875 16.9542 3.6875 18.9102V22.5977H55.3125V18.9102C55.3125 16.9542 54.5355 15.0783 53.1524 13.6952C51.7693 12.3122 49.8935 11.5352 47.9375 11.5352H11.0625ZM3.6875 41.0352V26.2852H55.3125V41.0352C55.3125 42.9911 54.5355 44.867 53.1524 46.2501C51.7693 47.6331 49.8935 48.4102 47.9375 48.4102H11.0625C9.10653 48.4102 7.23067 47.6331 5.84759 46.2501C4.46451 44.867 3.6875 42.9911 3.6875 41.0352ZM38.7188 37.3477C38.2298 37.3477 37.7608 37.5419 37.415 37.8877C37.0693 38.2334 36.875 38.7024 36.875 39.1914C36.875 39.6804 37.0693 40.1494 37.415 40.4951C37.7608 40.8409 38.2298 41.0352 38.7188 41.0352H46.0938C46.5827 41.0352 47.0517 40.8409 47.3975 40.4951C47.7432 40.1494 47.9375 39.6804 47.9375 39.1914C47.9375 38.7024 47.7432 38.2334 47.3975 37.8877C47.0517 37.5419 46.5827 37.3477 46.0938 37.3477H38.7188Z",
    fill: "url(#paint0_linear_78_389)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_389",
    x1: 29.5,
    y1: 11.5352,
    x2: 29.5,
    y2: 48.4102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseLogo5);
export default __webpack_public_path__ + "static/media/case-logo-5.90d3beb4316063502c16ee554d942c8e.svg";
export { ForwardRef as ReactComponent };